import React from 'react';
import {useEffect, useState} from 'react';
import FederalComponent from '../../join-commute/payment-screen/federal-component/FederalComponent';

export default function RetailOrCommuterRadio(props) {
    const [isRetail, updateIsRetail] = useState(props.isRetail);
    const [isCommuter, updateIsCommuter] = useState(props.isCommuter);

  function handleOptionClick(option) {
        updateIsRetail(option == 'isRetail');
        updateIsCommuter(option == 'isCommuter');
        props.updateIsRetail(option == 'isRetail');
        props.updateIsCommuter(option == 'isCommuter');
        props.onUpdateAuthorizedAmount();
  }

  function handleOptionKeyDown(e, option) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleOptionClick(option);
    }
  }

  return (
    <div className={`checkFederalCommute ${ props.isCvvZipValid ? 'zip-cvv-invalid' : ''}`} role="radiogroup" aria-labelledby='checkFederalCommute'>
    <label  tabIndex={0} className='checkFederalCommuteLabel' id='checkFederalCommute'>Is this a Commuter Benefit Card?*</label>
    <div className='radio-section'>
    <div
        tabIndex={0}
        role='radio'
        aria-checked={isCommuter === true}
        onClick={() => handleOptionClick('isCommuter')}
        onKeyDown={(e) => handleOptionKeyDown(e, 'isCommuter')}
        className={isCommuter === true ? 'radio active' : 'radio'}
        aria-labelledby='isCommuter'
      >
        <div className='round'></div>
        <label id="isCommuter" className='text'>Yes</label>
      </div>

      {
        isCommuter && 
        <FederalComponent
        authorizedAmount={props.authorizedAmount}
        onUpdateAuthorizedAmount={props.onUpdateAuthorizedAmount}
        updateIsAmountValid={props.updateIsAmountValid}
        maxAmount={props.maxAmount}
        isAmountValid={props.isAmountValid}
        isCommuter={isCommuter} />
      }
      <div
        tabIndex={0}
        role='radio'
        aria-checked={isRetail === true}
        onClick={() => handleOptionClick('isRetail')}
        onKeyDown={(e) => handleOptionKeyDown(e, 'isRetail')}
        className={isRetail === true ? 'radio active' : 'radio'}
        aria-labelledby='isRetail'
      >
        <div className='round'></div>
        <label id="isRetail" className='text'>No</label>
      </div>
    </div>
  </div>
  );
}